import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { ClientSession, Session } from "src/app/core/models/session";
import { SessionService } from "../../../../core/services/session.service";
import { AuthenticationService } from "../../../../core/services/authentication.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ErrorCodes } from "../../../../core/models/globals";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "../../../shared/components/confirm-dialog/confirm-dialog.component";
import { interval, Subscription, take, tap } from "rxjs";
import { SyncConfigService } from "../../../../core/services/sync-config.service";
import { ActivatedRoute } from "@angular/router";
@Component({
  selector: "app-client-session",
  templateUrl: "./client-session.component.html",
  styleUrls: ["./client-session.component.scss"],
})
export class ClientSessionComponent implements OnInit, OnDestroy {
  clientSessions: ClientSession[] = [];
  currentLoggedInUser = this.authenticationService.currentUserValue?.username;
  available: boolean;
  useVncFile: boolean = false;
  timePeriod: Number[] = [1, 2, 4, 6, 8, 10];
  dataReloadSubscription: Subscription;
  clientSessionTooltipHtml: string = "";
  userInfo: any;
  authType = this.authenticationService.getAuthenticationType().toString();
  constructor(
    private sessionService: SessionService,
    private spinner: NgxSpinnerService,
    private authenticationService: AuthenticationService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
    public syncConfig: SyncConfigService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const user = this.route.snapshot.queryParamMap.get("user");
    if (!this.authenticationService.currentUserValue) {
      this.router.navigate([`/Client/webapp/Login`], {
        queryParams: { user: user },
      });
      return;
    }
    this.spinner.show("sessions");
    this.loadClientSessionData();
    this.getUserInfoFromLocalStorage();
    //this.startDataReloadSub();
  }

  loadClientSessionData() {
    this.sessionService
      .getClientSessionsForUser(this.currentLoggedInUser)
      .pipe(tap(() => this.spinner.hide("sessions")))
      .subscribe({
        next: (data) => {
          this.spinner.hide();
          if (data == null) {
            this.available = false;
            return;
          }
          this.clientSessions = <ClientSession[]>(
            JSON.parse(JSON.stringify(data))
          );
        },
        error: (err) => {
          this.spinner.hide();
          this.available = false;
        },
      });
    this.available = true;
  }

  getSessionFromDeployment(
    depName: string,
    nodeGroup: string,
    platform: string
  ) {
    let dep = depName;
    let reqObj = { platform: platform };
    this.spinner.show(nodeGroup + `-${platform}`);
    this.sessionService
      .requestSessionFromDeployment(
        dep,
        reqObj,
        nodeGroup,
        this.currentLoggedInUser,
        this.timePeriod,
        true
      )
      .subscribe((data: any) => {
        let response = JSON.parse(data["message"]);
        if (
          data.actionCode != ErrorCodes.Succeeded &&
          data.actionCode != ErrorCodes.In_Transition
        ) {
          this.snackBar.open(response.FileContent, "Ok", { duration: 5000 });
          this.spinner.hide(nodeGroup + `-${platform}`);
          this.loadClientSessionData();
          return;
        }
        //this.spinner.hide("nodeGroup");
        this.loadClientSessionData();
        this.spinner.show(nodeGroup + `-${platform}`);
        setTimeout(() => {
          if (data.additionalInfo != null) {
            this.sessionService
              .checkSessionState(data.additionalInfo)
              .subscribe((data: any) => {
                if (data.state == "WTSReady") {
                  this.spinner.show(nodeGroup + `-${platform}`);
                  //this.sessionService.connectSessionClient(response.VmName, this.currentLoggedInUser, depName, this.userInfo, this.authType).subscribe(
                  //  {
                  //    next: (data) => {
                  //      this.spinner.hide(depName)
                  //      if (data == null) {
                  //      }
                  //      this.clientSessions = <ClientSession[]>JSON.parse(JSON.stringify(data))
                  //    }, error: (err) => {
                  //      this.spinner.hide(depName);
                  //    }
                  //  }
                  //)
                  this.sessionService
                    .connectSession(
                      response.VmName,
                      this.currentLoggedInUser,
                      depName
                    )
                    .pipe(take(1))
                    .subscribe({
                      next: (data: any) => {
                        this.spinner.hide(nodeGroup + `-${platform}`);
                        let response = JSON.parse(data["message"]);
                        if (data?.actionCode != ErrorCodes.Succeeded) {
                          this.snackBar.open(response.FileContent, "Ok", {
                            duration: 5000,
                          });
                          return;
                        }
                        this.triggerApplication(response, nodeGroup, platform);
                      },
                      error: (err) => {
                        this.spinner.hide(nodeGroup + `-${platform}`);
                      },
                    });
                }
              });
            this.loadClientSessionData();
          }
        }, 5000);
      });
  }

  clientConnectSession(session: Session) {
    this.spinner.show(session.deployment);
    this.sessionService
      .connectSessionClient(
        session.vmName,
        session.subscriberUserId,
        session.deployment,
        this.userInfo,
        this.authType
      )
      .subscribe({
        next: (data) => {
          this.spinner.hide(session.deployment);
          if (data == null) {
          }
          this.clientSessions = <ClientSession[]>(
            JSON.parse(JSON.stringify(data))
          );

          this.clientSessions.map((cs) => {
            cs.sessions.map((session) => {
              if (session.vmName == "" || session.vmName == null) {
                session.name = "Waiting" + session.name;
                return session;
              }
            });
          });
        },
        error: (err) => {
          this.spinner.hide(session.deployment);
        },
      });
  }

  clientConnectSession2(session: Session) {
    this.spinner.show(session.deployment);
    this.sessionService
      .connectSession(
        session.vmName,
        session.subscriberUserId,
        session.deployment
      )
      .pipe(take(1))
      .subscribe({
        next: (data: any) => {
          this.spinner.hide(session.deployment);
          let response = JSON.parse(data["message"]);
          if (data?.actionCode != ErrorCodes.Succeeded) {
            this.snackBar.open(response.FileContent, "Ok", {
              duration: 5000,
            });
            return;
          }
          this.triggerApplication(response, "", "");
        },
        error: (err) => {
          this.spinner.hide(session.deployment);
        },
      });
  }

  triggerApplication(response, nodeGroup, platform) {
    if (nodeGroup != null || nodeGroup != "") {
      this.spinner.show(nodeGroup + `-${platform}}`);
    }
    this.sessionService.triggerApplicationFromClient(response).subscribe({
      next: (data) => {
        this.spinner.hide(nodeGroup + `-${platform}}`);
      },
      error: (err) => {
        this.spinner.hide(nodeGroup + `-${platform}}`);
      },
    });
  }

  removeSession(session: Session) {
    let message = `Do you want to remove ${session.user} from ${session.vmName}?`;
    if (session.vmName == null || session.vmName == "") {
      message = `Do you want to remove ${session.user} session?`;
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        autoFocus: false,
        disableClose: false,
        width: "25%",
        data: {
          titleMessage: "Remove Session",
          bodyMessage: message,
          cancelText: "Cancel",
          submitText: "Proceed",
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.snackBar.open("Action is in progress.", "Ok", {
            duration: 5000,
          });
          setTimeout((x) => {}, 2000);
          let sessionVm = session.vmName;
          if (session.vmName == "" || session.vmName == null) {
            sessionVm = "NA";
          }
          this.sessionService
            .removeSession(
              sessionVm.toLowerCase(),
              session.user.toLowerCase(),
              session.deployment.toLowerCase(),
              this.currentLoggedInUser.toLowerCase()
            )
            .subscribe({
              next: (data: any) => {
                if (data.status == 200) {
                  this.snackBar.open(data.actionMessage, "Ok", {
                    duration: 5000,
                  });
                }
                this.loadClientSessionData();
              },
              error: (err) => {
                if (err?.error?.status == 401 || err?.error?.status == 404) {
                  this.snackBar.open("Action can not be performed.", "Ok", {
                    duration: 5000,
                  });
                }
              },
            });
        }
      });
  }

  startDataReloadSub() {
    this.dataReloadSubscription = interval(
      this.syncConfig.config.clinetApp?.listReqInterval
        ? this.syncConfig.config.clinetApp?.listReqInterval
        : 30000
    ).subscribe(async () => {
      await this.loadClientSessionData();
    });
  }

  refreshComponent() {
    let url = this.router.url.split("?")[0];
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }

  getToolTipForSession(session: Session) {
    this.clientSessionTooltipHtml = null;
    this.clientSessionTooltipHtml = session.nodeDescription;
    return this.clientSessionTooltipHtml;
  }

  getUserInfoFromLocalStorage() {
    this.userInfo = JSON.parse(localStorage.getItem("currentUser"));
  }

  ngOnDestroy() {
    this.dataReloadSubscription?.unsubscribe();
  }
}
